module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    class: {
      'modal-hidden': !_vm.value
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-wrap",
    class: 'modal-' + _vm.size
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('Icon', {
    attrs: {
      "type": "close-round"
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default", [_vm._v("这是内容")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('Button', {
    attrs: {
      "type": "ghost"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel_btn')))]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('determine_btn')))])])], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d12c5e58","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/Modal.vue
// module id = 853
// module chunks = 0